import { Filter } from 'lucide-react'

// Placeholder for future metadata filtering
export function ContextFilters() {
    return (
        <div className="p-4 bg-white/5 border border-white/10 rounded-lg opacity-50 cursor-not-allowed">
            <div className="flex items-center gap-2 text-gray-400 mb-2">
                <Filter className="w-4 h-4" />
                <h3 className="text-sm font-semibold">Context Filters</h3>
            </div>
            <p className="text-xs text-gray-500 italic">
                Metadata filtering is coming soon in API v2.
            </p>
        </div>
    )
}
